import {
	FETCH_ADD_GOOD_DEAL_CATEGORY,
	SET_ADD_GOOD_DEAL_CATEGORY_RESULT,
	FETCH_UPDATE_GOOD_DEAL_CATEGORY,
	SET_UPDATE_GOOD_DEAL_CATEGORY_RESULT,
	FETCH_REORDER_GOOD_DEALS_CATEGORIES,
	SET_REORDER_GOOD_DEALS_CATEGORIES_RESULT,
	SET_GOOD_DEAL_CATEGORY_FAILURE,
	FETCH_GET_GOOD_DEALS_CATEGORIES_PICTOS,
	SET_GOOD_DEALS_CATEGORIES_PICTOS
} from "./types";
import { apiAction } from "./api";
import { fetchGetGoodDealsCategories } from "./gooddeal";

// Cached images used as good deals categories pictograms
const TYPE_AD_CATEGORY = 5;

const setGoodDealCategoryFailure = error => ({
	type: SET_GOOD_DEAL_CATEGORY_FAILURE,
	payload: error
});

// The categories list is reloaded after every change
const onCategoriesChanged = type => data =>
	[{ type, payload: data }, fetchGetGoodDealsCategories()];

// category: { name, lang: { en: { name } }, picto, bgColor }
export function fetchAddGoodDealCategory(category) {
	return apiAction({
		url: "/gooddeals/categories",
		method: "POST",
		data: category,
		onSuccess: onCategoriesChanged(SET_ADD_GOOD_DEAL_CATEGORY_RESULT),
		onFailure: setGoodDealCategoryFailure,
		label: FETCH_ADD_GOOD_DEAL_CATEGORY
	});
}

export function fetchUpdateGoodDealCategory(id, category) {
	return apiAction({
		url: "/gooddeals/categories/" + id,
		method: "PUT",
		data: category,
		onSuccess: onCategoriesChanged(SET_UPDATE_GOOD_DEAL_CATEGORY_RESULT),
		onFailure: setGoodDealCategoryFailure,
		label: FETCH_UPDATE_GOOD_DEAL_CATEGORY
	});
}

// categoriesIds: ids of all the categories, in the new order
export function fetchReorderGoodDealsCategories(categoriesIds) {
	return apiAction({
		url: "/gooddeals/categories/order",
		method: "POST",
		data: categoriesIds,
		onSuccess: onCategoriesChanged(SET_REORDER_GOOD_DEALS_CATEGORIES_RESULT),
		onFailure: setGoodDealCategoryFailure,
		label: FETCH_REORDER_GOOD_DEALS_CATEGORIES
	});
}

export function fetchGetGoodDealsCategoriesPictos() {
	return apiAction({
		url: "/globalinformations/cachedImages",
		method: "GET",
		data: { types: [TYPE_AD_CATEGORY] },
		onSuccess: data => ({
			type: SET_GOOD_DEALS_CATEGORIES_PICTOS,
			payload: data
		}),
		onFailure: setGoodDealCategoryFailure,
		label: FETCH_GET_GOOD_DEALS_CATEGORIES_PICTOS,
		withCredentials: false
	});
}
